import { Alert, Descriptions, Drawer, Spin, Typography } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useAuditEntry } from "../hooks/useAudit";
import { amalNomi } from "../utils/actions";
import { AuditDiff } from "./AuditDiff";

const { Title } = Typography;

interface AuditDetailDrawerProps {
	entryId: string | null;
	onClose: () => void;
}

/**
 * Bitta audit yozuvining tafsiloti.
 *
 * ⚠️ `routePath` XOM ko'rsatiladi (`/api/v1/employees/:id`) — u audit
 * registrining kaliti bilan bir xil EMAS (kontrakt §4.4) va uni
 * «tozalash» yozuvni haqiqatdan uzoqlashtirardi.
 */
export function AuditDetailDrawer({ entryId, onClose }: AuditDetailDrawerProps) {
	const { t } = useTranslation("audit");
	const { data, isLoading, isError } = useAuditEntry(entryId);

	return (
		<Drawer title={t("detailDrawer.title")} size={720} open={entryId !== null} onClose={onClose}>
			{isError ? <Alert type="error" message={t("detailDrawer.loadError")} showIcon /> : null}
			{isLoading && !isError ? <Spin /> : null}
			{data ? (
				<>
					<Descriptions column={1} size="small" bordered>
						<Descriptions.Item label={t("detailDrawer.atLabel")}>
							{dayjs(data.at).format("DD.MM.YYYY HH:mm:ss")}
						</Descriptions.Item>
						<Descriptions.Item label={t("detailDrawer.actorLabel")}>
							{data.actorName ?? t("systemActor")}
						</Descriptions.Item>
						<Descriptions.Item label={t("detailDrawer.actionLabel")}>
							{amalNomi(data.action, t)}
						</Descriptions.Item>
						<Descriptions.Item label={t("detailDrawer.resourceLabel")}>
							{data.resourceType}
						</Descriptions.Item>
						<Descriptions.Item label={t("detailDrawer.resourceIdLabel")}>
							{data.resourceId ?? "—"}
						</Descriptions.Item>
						<Descriptions.Item label={t("detailDrawer.reasonLabel")}>
							{data.reason ?? "—"}
						</Descriptions.Item>
						<Descriptions.Item label={t("detailDrawer.routeLabel")}>
							{data.method ?? "—"} {data.routePath ?? ""}
						</Descriptions.Item>
						{/* ⚠️ IP `X-Forwarded-For` ning OXIRGI elementidan olinadi
						    (birinchisini klient soxtalashtira oladi). */}
						<Descriptions.Item label={t("detailDrawer.ipLabel")}>
							{data.ip ?? "—"}
						</Descriptions.Item>
					</Descriptions>

					<Title level={5} className="!mt-6 !mb-2">
						{t("detailDrawer.changesTitle")}
					</Title>
					<AuditDiff diff={data.diff} />
				</>
			) : null}
		</Drawer>
	);
}
